import { useQuery } from '@tanstack/react-query';
import {
  clientGetConversations,
  clientGetNumberOfUnreadConversations,
  getConversation,
  useGraphqlClient,
} from '../graphql';
import { conversationKeys } from './queryKeys';
import { ConversationQueryVariables } from '../generated/graphql';

export const useNumberOfUnreadConversations = (
  firmId?: string,
  options: { refetchInterval: number | false } = { refetchInterval: false }
) => {
  const gqlClient = useGraphqlClient();

  const numberOfUnreadConversationsQuery = useQuery({
    refetchInterval: options.refetchInterval,
    queryKey: conversationKeys.numberOfUnreadConversations(),
    queryFn: () => clientGetNumberOfUnreadConversations(gqlClient, { firmID: firmId }),
  });

  return {
    numberOfUnreadConversationsQuery,
    numberOfUnreadConversations: numberOfUnreadConversationsQuery.data ?? 0,
  };
};

export const useConversations = (
  firmId?: string,
  options: { refetchInterval: number | false } = { refetchInterval: false }
) => {
  const gqlClient = useGraphqlClient();

  const conversationsQuery = useQuery({
    refetchInterval: options.refetchInterval,
    queryKey: conversationKeys.conversations(),
    queryFn: async () => {
      const res = await clientGetConversations(gqlClient, {
        firmID: firmId,
        cursor: undefined,
      });
      return res.items;
    },
  });

  return {
    conversationsQuery,
    conversations: conversationsQuery.data || [],
  };
};

export const useConversation = (vars: ConversationQueryVariables) => {
  const gqlClient = useGraphqlClient();

  const conversationQuery = useQuery({
    enabled: !!vars.id || !!vars.firmClientID,
    queryKey: conversationKeys.conversation(vars),
    queryFn: () => {
      if (vars.id || vars.firmClientID) return getConversation(gqlClient, vars);
    },
  });

  return {
    conversationQuery,
    conversation: conversationQuery.data,
  };
};
